import React, { Component } from "react";
import '../App.css'
//import {Link} from 'react-router-dom';
// import { withRouter } from "react-router-dom";

import PropTypes from "prop-types";

import Drawer from '@material-ui/core/Drawer';

// import Divider from '@material-ui/core/Divider'

import { withStyles } from "@material-ui/core/styles";

import { MenuItem, createMuiTheme, MuiThemeProvider } from "@material-ui/core";


// const drawerWidth = 250;

const drawerWidth = 160;


const styles = theme => ({
  root: {
    display: "flex"
  },
  selected: {},


  drawer: {

    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    
    backgroundColor: '#422963',
    // backgroundColor: 'black',
    // backgroundColor: 'transparent',
    // backgroundColor: ' #bac5e3',       //'#e0e8fa' , 
    width: 190,
    marginTop: 56,
    border: "none",
    minHeight: 500,
    overflowY: "auto",
    [theme.breakpoints.up("sm")]: {
      marginTop: 64,
      width: drawerWidth,
      position: 'fixed'

    }
  }
});

const theme = createMuiTheme({
  overrides: {
    MuiMenuItem: {
      "root":{
        selected: {
          background: "linear-gradient(to bottom, #422963 -5%, #422963 -2%);"
        }
      }
    }
  }
});

class PersistentDrawerLeft extends Component {

  constructor() {
    super();

    this.state = {
      navigateEvents: false,
      navigateCompanies: false,
      navigateUserAdmin: false,
      navigateAssets: false,
      navigateShows: false,

      noteSelect: true,

      eventsSelect: false,
      companiesSelect: false,
      userAdminSelect: false,
      assetsSelect: false,
      showsSelect: false,
      data: []
    }

    this.handleEvents = this.handleEvents.bind(this)
    this.handleCompanies = this.handleCompanies.bind(this)
    this.handleUserAdmin = this.handleUserAdmin.bind(this)
    this.handleAssets = this.handleAssets.bind(this)
    this.handleShows = this.handleShows.bind(this)
  }

  async handleNotes(event) {
    await this.setState({
      navigateEvents: false,
      navigateCompanies: false,
      navigateUserAdmin: false,
      navigateAssets: false,
      navigateShows: false,

      noteSelect: true,

      eventsSelect: false,
      companiesSelect: false,
      userAdminSelect: false,
      assetsSelect: false,
      showsSelect: false
    })

    this.props.drawerClose(event);
    // this.props.handleNavigation(
    //   this.state.navigateEvents,
    //   this.state.navigateCompanies,
    //   this.state.navigateUserAdmin,
    //   this.state.navigateAssets,
    //   this.state.navigateShows

    // )
    this.props.navigation.navigate("/user")
  }
  redirectToTarget = () => {
    // history.push('/card')


    // hashHistory.push(/dataGenerate)
  }

  async handleEvents(event) {
    await this.setState({
      navigateEvents: true,
      navigateCompanies: false,
      navigateUserAdmin: false,
      navigateAssets: false,
      navigateShows: false,


      noteSelect: false,

      eventsSelect: true,
      companiesSelect: false,
      userAdminSelect: false,
      assetsSelect: false,
      showsSelect: false

    })
    this.props.drawerClose(event);
    this.props.handleNavigation(
      this.state.navigateEvents,
      this.state.navigateCompanies,
      this.state.navigateUserAdmin,
      this.state.navigateAssets,
      this.state.navigateShows
    )
    // this.props.history.push("user")
  }

  async handleCompanies(event) {
    await this.setState({
      navigateEvents: false,
      navigateCompanies: true,
      navigateUserAdmin: false,
      navigateAssets: false,
      navigateShows: false,


      noteSelect: false,

      eventsSelect: false,
      companiesSelect: true,
      userAdminSelect: false,
      assetsSelect: false,
      showsSelect: false
    })
    this.props.drawerClose(event);
    // this.props.handleNavigation(
    //   this.state.navigateEvents,
    //   this.state.navigateCompanies,
    //   this.state.navigateUserAdmin,
    //   this.state.navigateAssets,
    //   this.state.navigateShows,
    // )
    this.props.navigation.navigate("/user")
  }


  async handleUserAdmin(event) {
    await this.setState({
      navigateEvents: false,
      navigateCompanies: false,
      navigateUserAdmin: true,
      navigateAssets: false,
      navigateShows: false,


      noteSelect: false,

      eventsSelect: false,
      companiesSelect: false,
      userAdminSelect: true,
      assetsSelect: false,
      showsSelect: false
    })

    this.props.history.push('/user')

    this.props.drawerClose(event);
    // this.props.handleNavigation(
    //   this.state.navigateEvents,
    //   this.state.navigateCompanies,
    //   this.state.navigateUserAdmin,
    //   this.state.navigateAssets,
    //   this.state.navigateShows
    // )
    this.props.navigation.navigate("/user")
  }


  async handleAssets(event) {
    await this.setState({
      navigateEvents: false,
      navigateCompanies: false,
      navigateUserAdmin: false,
      navigateAssets: true,
      navigateShows: false,


      noteSelect: false,

      eventsSelect: false,
      companiesSelect: false,
      userAdminSelect: false,
      assetsSelect: true,
      showsSelect: false
    })
    this.props.drawerClose(event);
    // this.props.handleNavigation(
    //   this.state.navigateEvents,
    //   this.state.navigateCompanies,
    //   this.state.navigateUserAdmin,
    //   this.state.navigateAssets,
    //   this.state.navigateShows
    // )
    this.props.navigation.navigate("/user")
  }


  async handleShows(event) {
    await this.setState({
      navigateEvents: false,
      navigateCompanies: false,
      navigateUserAdmin: false,
      navigateAssets: false,
      navigateShows: true,


      noteSelect: false,

      eventsSelect: false,
      companiesSelect: false,
      userAdminSelect: false,
      assetsSelect: false,
      showsSelect: true
    })
    this.props.drawerClose(event);
    // this.props.handleNavigation(
    //   this.state.navigateEvents,
    //   this.state.navigateCompanies,
    //   this.state.navigateUserAdmin,
    //   this.state.navigateAssets,
    //   this.state.navigateShows
    // )

    this.props.navigation.navigate("/user")
  }












  render() {













    const { classes } = this.props;
    let displayLabels = this.state.data;
    if (this.state.data !== "") {
      displayLabels = this.state.data.map((key, i) => (

        <MenuItem
          className={classes.menuItem}
          id="sideMenu" //onClick={() => this.displaySearchLabels(key.label)}
          key={i}
        >
          <img
            //  src={require('../assets/Hamburger_icon.svg.png')}

            alt="note icon"
            id="NavButton"
          />
          <div className="sampl">{key.label}</div>
        </MenuItem>


      ));
    }





    return (
      <div className={classes.root}>
        <MuiThemeProvider theme={theme}>
          <Drawer
            id="drawer"
            className={classes.drawer}
            variant="persistent"
            anchor="left"
            open={this.props.AppBarProps}
            classes={{
              paper: classes.drawerPaper
            }}
          >


            {/* <MenuItem
              style={{ marginTop: "3%" }}
              className={classes.menuItem}
              id="sideMenu"
              selected={this.state.noteSelect}
              onClick={() => this.handleNotes("ChromaFan")}
            >
              <img
                src={require("../assets/Notes.svg")}
                alt="note icon"
                id="NavButton"
              />
              <div className="sampl">Notes</div>
            </MenuItem> */}

           <MenuItem
              className={classes.menuItem}
              id="sideMenu"
              selected={this.state.eventsSelect}>
              {/* onClick={() => this.handleEvents('Events')}> */}

              {/* <img
                src={require('../assets/event-24px.svg')}
                alt='eventIcon'
                id="NavButton"
              /> */}
              <a className="sampl" href="/teamsScreen">Teams</a>

            </MenuItem>

            {/* <MenuItem
              className={classes.menuItem}
              id="sideMenu"
              selected={this.state.eventsSelect}>
              <a className="sampl" href="/eventScreen">Events</a>

            </MenuItem> */}


            {/* <Divider style={{backgroundColor:'black'}} /> */}


            <div id="showLabelDrawer">{displayLabels.reverse()}</div>
            {/* <MenuItem
              className={classes.menuItem}
              id="sideMenu"
              selected={this.state.assetsSelect}
              onClick={() => this.handleAssets('Assets')}>


              <a className="sampl" href="/AssetsPage">Assets</a>


            </MenuItem> */}


            {/* { <MenuItem
              className={classes.menuItem}
              id='sideMenu'
              selected={this.state.showsSelect}
              onClick={() => this.handleShows('Shows')}>

              {/* <img
                src={require('../assets/local_play-24px.svg')}
                alt='ShowsIcon'
              id="NavButton" /> }


              <a className="sampl" href='/ShowsPage' >Shows</a>

            </MenuItem> } */}
           
           
            { <MenuItem
              className={classes.menuItem}
              id='sideMenu'
              selected={this.state.showsSelect}
              onClick={() => this.handleShows('Shows')}>

              {/* <img
                src={require('../assets/local_play-24px.svg')}
                alt='ShowsIcon'
              id="NavButton" /> */}


              <a className="sampl" href='/ManageAdmin' >Admin</a>

            </MenuItem> }


          </Drawer>
        </MuiThemeProvider>
      </div>
    )
  }
}


PersistentDrawerLeft.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(PersistentDrawerLeft);

